import { styled } from '@f8n-frontend/stitches';

import Box from 'components/base/Box';

const SearchBarIcon = styled(Box, {
  top: '50%',
  transform: 'translateY(-50%)',
  position: 'absolute',
  color: '$black30',
  transition: 'color $0 $ease',
  cursor: 'pointer',
  display: 'flex',

  variants: {
    color: {
      white: {
        color: '$white100',
        '&[data-active=true]': {
          color: '$black100',
        },
        '@hover': {
          '&:hover': {
            color: '$black100',
          },
        },
      },
      black: {
        color: '$black50',
        '&[data-active=true]': {
          color: '$black100',
        },
        '@hover': {
          '&:hover': {
            color: '$black100',
          },
        },
      },
    },
    focused: {
      true: {
        $$iconColor: '$colors$black30',
        color: '$$iconColor',
        '@hover': {
          '&:hover': {
            color: '$black100',
          },
        },
      },
    },
  },
  compoundVariants: [
    {
      color: 'white',
      focused: true,
      css: {
        $$iconColor: '$colors$black30',
      },
    },
  ],
});

export default SearchBarIcon;
